/* eslint-disable no-unused-vars */
<template>
  <div class="count-down-timer">
    <div class="count-down-timer__area">
      <!-- Timer Code start  -->
      <div class="count-down-timer__area__base-timer">
        <radial-progress-bar
          :diameter="diameter"
          :completed-steps="strokeDasharray"
          total-steps="60"
          :animate-speed="1000"
          :stroke-width="strokeWidth"
          :inner-stroke-width="innerStrokeWidth"
          :start-color="startColor"
          :stop-color="stopColor"
          :inner-stroke-color="innerStrokeColor">
          <p class="base-timer__label">{{ timeLeft }}</p>
        </radial-progress-bar>
      </div>
      <!-- Timer code end  -->
      <Button
        label="Refresh"
        class="refresh-button"
        appearance="primary"
        :disabled="isRefreshButtonDisabled"
        @onClick="refreshData" />
    </div>
  </div>
</template>

<script>
//component
import RadialProgressBar from "vue-radial-progress";
export default {
  name: "CountDownTimer",
  components: {
    RadialProgressBar,
  },
  props: {
    isRefreshButtonDisabled: { type: Boolean, required: true },
    refreshTimeInterval: { type: Number, required: false },
  },
  data() {
    return {
      timeLeft: "",
      strokeDasharray: 60,
      diameter: 45,
      strokeWidth: 2,
      innerStrokeWidth: 2,
      startColor: "#40ab35",
      stopColor: "#40ab35",
      innerStrokeColor: "#ffffff",
      refreshTime: this.refreshTimeInterval || 30,
    };
  },
  watch: {
    isRefreshButtonDisabled() {
      if (this.isRefreshButtonDisabled) {
        this.timeLeft = this.formatTimeLeft(this.refreshTime || 30);
        this.startTimer();
      }
    },
  },

  mounted() {
    this.timeLeft = this.formatTimeLeft(this.refreshTime || 30);
    this.startTimer();
  },
  methods: {
    refreshData() {
      this.$emit("fetchDisputeDetailsByBulkIds");
    },
    setCircleDasharray(timeLeft, timeLimit, fullDashArray) {
      this.strokeDasharray = ((timeLeft / timeLimit) * fullDashArray).toFixed(
        0
      );
    },
    formatTimeLeft(time) {
      const minutes = Math.floor(time / 60);
      let seconds = time % 60;
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      return `${minutes}:${seconds}`;
    },
    startTimer() {
      const TIME_LIMIT = this.refreshTime || 30;
      let timePassed = 0;
      let timeLeft = TIME_LIMIT;
      const FULL_DASH_ARRAY = 60;
      const timerInterval = setInterval(() => {
        timePassed = timePassed += 1;
        timeLeft = TIME_LIMIT - timePassed;
        this.timeLeft = this.formatTimeLeft(timeLeft);

        this.setCircleDasharray(timeLeft, TIME_LIMIT, FULL_DASH_ARRAY);
        if (timePassed === TIME_LIMIT) {
          clearInterval(timerInterval);
          this.$emit("updateRefreshButtonDisabledFlag");
        }
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
.count-down-timer {
  &__area {
    margin-left: 2rem;
    display: flex;
    align-items: center;

    &__base-timer {
      position: relative;
      height: 46px;
      width: 46px;
    }
  }
}
</style>
<style lang="scss">
.refresh-button {
  max-height: 42px;
  margin-left: 1rem;
}
.base-timer__label {
  font-size: 12px;
}
</style>
